//* Vue
import type { SetupContext } from "vue";
//* 组件库
import type { UiModal } from "various-ui";
//* 组件属性
import type { ModuleEmits } from "../index";

export const useComposable = (emits: SetupContext<typeof ModuleEmits>["emit"]) => {
    //* 静态属性
    const vars = { data: <any>undefined };

    //* 节点
    const nodes = {
        modal: ref<InstanceType<typeof UiModal>>(),
    };

    //* 函数列表
    const methods = {
        open: (data?: any) => {
            vars.data = data; //* 数据缓存
            nodes.modal.value?.openModal(); //* 启动窗口
        },

        close: () => {
            emits("cancel", vars.data); //* 事件响应
            nodes.modal.value?.closeModal(); //* 关闭窗口
        },

        confirm: () => {
            emits("confirm", vars.data); //* 事件响应
            nodes.modal.value?.closeModal(); //* 关闭窗口
        },
    };

    return { nodes, methods };
};
